<template>
  <el-card class="box-card mt10">
    <div class="date-item">
      <div class="date-item">
        <el-link type="primary" :underline="false">会客统计</el-link>
        <div class="order-today">
          <el-link :type="orderToday === 2?'primary':''" :underline="false" @click="handleOrderToday(2)">本周</el-link>
          <el-link :type="orderToday === 3?'primary':''" :underline="false" @click="handleOrderToday(3)">本月</el-link>
        </div>
        <div class="today-data" v-if="todayData">
          <p>今日会客数<br /><span>{{todayData.totalCount}}</span></p>
          <p>今日好评<br /><span>{{todayData.goodCount}}</span></p>
          <p>今日差评<br /><span>{{todayData.badCount}}</span></p>
        </div>
      </div>
      <echarts-vue :echart-data="echartData" echartName="echarts" />
      </div>
  </el-card>
</template>

<script>
import echartsVue from './echarts.vue'
import homeStatisticsApi from '@/api/home'
import { getWeekDates, getMonthDates, getDayOfWeek, formatDate, isToday } from '@/utils/index'
export default {
  components: { echartsVue },
  data() {
    return {
      dateTime: [],
      orderToday: 2, //2 周 3 月
      echartsData: [],
      xData: [],
      todayData: null
    }
  },
  created() {
    this.getfindMoneyTotalByDate();
    // this.getEcharts()
  },
  methods: {
    getfindMoneyTotalByDate() {
      let start = this.orderToday === 2 ? getWeekDates()[0] : getMonthDates()[0]
      let end = this.orderToday === 2 ? getWeekDates()[1] : getMonthDates()[1]
      let params = {
        startTime: start + ' 00:00:00',
        endTime: end + ' 23:59:59',
        timeType: 1
      }
      homeStatisticsApi.imConversationStatistics(params).then(({ data }) => {
        if (data.length > 0) {
         
          let find = data.find(it => isToday(it.startTime))
          console.log(find)
          this.todayData = find;
          this.calcDate(data)
          this.getEcharts(data)
        }
      })
    },
    calcDate(data) {
      let dateList = []
      data.forEach((item, index) => {
        let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        let str = this.orderToday === 2 ? `周${getDayOfWeek(date)}` : ''
        dateList.push(`${str} ${date}`)
      });
      this.xData = dateList
    },
    handleOrderToday(type) {
      if (this.orderToday === type) return
      this.orderToday = type
      this.getfindMoneyTotalByDate();
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "会客数", color: "#4DE1E9", key: "totalCount", },
        { name: "好评", color: "#C11FFD", key: "goodCount", },
        { name: "差评", color: "#02A4FF", key: "badCount", },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbol: 'none' };
      } else if (chartType === 'bar') {
        itemStyle = { borderRadius: [30, 30, 0, 0] }
        param = { type: "bar", barWidth: "10%", barCategoryGap: "30%" };
      }
      return ydata.map(item => {
        let dataArr = []
        datalist.forEach(itt => {
          dataArr.push({ value: itt[item.key], percent: -1 })
        })
        return {
          name: item.name, ...param, data: dataArr,
          itemStyle: { ...itemStyle, color: item.color }
        }
      })
    }
  },
  computed: {
    echartData() {
      return {
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.date-item {
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .order-today {
    float: right;
  }
}
.order-cont {
  display: flex;
  // justify-content: space-between;
  margin: 20px 0;
  div {
    font-size: 16px;
    color: #000;
    width: 25%;
    display: inline-block;
    span {
      font-size: 48px;
    }
  }
}
.el-link {
  padding-left: 20px;
}
.tit1 {
  font-size: 16px;
  text-align: right;
  padding: 10px 0;
}
.tit2 {
  font-size: 16px;
  color: #6c6c6c;
  font-weight: 800;
  text-align: right;
  span {
    color: #000000;
    font-size: 30px;
    margin-right: 10px;
  }
}
.today-data {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  p {
    font-size: 16px;
    margin: 8px 0 5px 36px;
    span {
      font-size: 30px;
      font-weight: bold;
    }
  }
}
</style>